<template>
  <div class="order-detail">
    <div class="order-main">
      <div class="lable">订单状态</div>
      <div class="type-box">
        <div class="box-left">
          <p class="order-type"><span>当前订单状态：</span><span>{{orderDetail.Status | orderType}}</span></p>
          <p v-if="orderDetail.Status == 60"><span class="ordinary-txt">物流状态：</span><span class="red-txt">暂无信息</span></p>
          <p v-if="orderDetail.Status == 50 || orderDetail.Status == 40"><span class="ordinary-txt">物流状态：</span><span class="red-txt">订单已签收</span></p>
          <p v-if="orderDetail.Status == 20"><span class="ordinary-txt">物流状态：</span><span class="red-txt">{{logisticsInfo.ContentList ? '商品正在配送中' :'商品正在出库中，暂无物流信息'}}</span></p>
          <div v-if="orderDetail.Status == 10">
            <p><span class="ordinary-txt">需付款：</span><span class="red-txt">￥{{orderDetail.Amount}}</span></p>
            <p><span class="ordinary-txt">剩余支付时间：</span><span class="red-txt">{{timeLeft(orderDetail.CreateTime)}}</span></p>
          </div>
        </div>
        <div class="box-right">
          <span class="border-btn" v-if="orderDetail.Status == 10" @click="paymentFun">去支付</span>
          <span class="txt-btn" v-if="orderDetail.Status == 10" @click="cancelOrder">取消订单</span>
          <span class="border-btn" v-if="orderDetail.Status == 20" @click="confirmReceipt">确认收货</span>
          <span class="border-btn" v-if="orderDetail.Status == 50" @click="jumpLogistics">查看物流</span>
        </div>
      </div>
      <div class="lable" v-if="orderDetail.Status !== 60">物流信息</div>
      <div class="logistics" v-if="orderDetail.Status !== 60">
        <div class="logistics-list" v-if="logisticsInfo.ContentList">
          <div class="logistics-left">
            <img src="../../assets/icon/blue_wl.png" alt="">
            <p>
              <span>{{logisticsInfo.LogisticsCompanyName}}</span>
              <span>运单号：{{logisticsInfo.LogisticsCode}}</span>
            </p>
          </div>
          <div class="logistics-right">
            <ul>
              <li v-for="(item, index) in logisticsInfo.ContentList" :key="index">
                <span class="time">{{item.Time}}</span>
                <i class="none-icon"></i>
                <span class="tips">{{item.Description}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="logistics-box" v-else>
          <img src="../../assets/icon/wl_icon.png" alt="">
          <span>暂无物流信息</span>
        </div>
      </div>
      <div class="lable">订单信息</div>
      <div class="order-info">
        <p><span class="bold-txt">收货地址：</span><span>{{orderDetail.ReceiverName}}，{{orderDetail.ReceiverPhone}}，{{orderDetail.ReceiverProvinceName + orderDetail.ReceiverCityName + orderDetail.ReceiverDistrictName + orderDetail.ReceiverStreetName + orderDetail.ReceiverAddress}}</span></p>
        <p><span class="bold-txt">订单编号：</span><span>{{orderDetail.OrderNo}}</span></p>
        <p><span class="bold-txt">下单时间：</span><span>{{orderDetail.CreateTime}}</span></p>
        <div class="table-box">
          <div class="tab-header">
            <span class="tab1">商品信息</span>
            <span class="tab2">单价</span>
            <span class="tab2">数量</span>
            <span class="tab2">实付款</span>
            <span class="tab5">操作</span>
          </div>
          <div class="goods-list">
            <div class="goods-box">
              <div class="goods-item">
                <div class="goods">
                  <img class="img" :src="skuData.SkuPictureUrl" alt="">
                  <div class="txt-box">
                    <span class="txt">{{skuData.SkuName}}</span>
                    <span class="buy-num">订单号：{{orderDetail.OrderNo}}</span>
                  </div>
                </div>
                <span class="tab2">￥{{skuData.SkuPrice}}</span>
                <span class="tab2">{{skuData.SkuNumber}}</span>
                <span class="tab2">￥{{orderDetail.Amount}}</span>
                <span class="tab5">
                  <span class="btn btn-border">联系客服</span>
                  <span  class="btn btn-border" v-if="orderDetail.Status == 20">退款</span>
                  <span  class="btn btn-border" v-if="orderDetail.Status == 40" @click="applyReturn">退换货</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="price-box">
          <p><span>{{skuData.SkuNumber}}件商品，总金额：</span><span class="money">¥{{orderDetail.TotalAmount}}</span></p>
          <p><span>已优惠：</span><span class="money">0.00</span></p>
          <p><span>运费：</span><span class="money">0.00</span></p>
          <p><span>应付总额：</span><span class="red-txt">￥{{orderDetail.Amount}}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getTimeLeftToSomeHourLater} from '../../../util/publicMethod'
import {
  UserOrderDetail,
  UserOrderCancel,
  UserOrderLogistics, // 订单物流
  UserOrderReceipt
} from '../../api/api'
export default {
  name: 'orderDetail',
  filters:{
    orderType(val){
      if(val == 10){
        return '等待付款'
      } else if(val == 20){
        return '待收货'
      } else if(val == 30){
        return '已发货'
      } else if(val == 40){
        return '已收货'
      } else if(val == 50){
        return '交易完成'
      } else if(val == 60){
        return '已取消'
      } else if(val == 70){
        return '已关闭'
      }
    }
  },
  data(){
    return{
      orderDetail: {},
      skuData: {},
      logisticsInfo: {}
    }
  },
  created(){
    this.getOrderDetail()
    this.getUserOrderLogistics()
  },
  methods:{
    applyReturn(){
      this.$router.push({path: '/personalCenter/applyReturn'})
    },
    jumpLogistics(){
      this.$router.push({path: '/personalCenter/logistics', query: {orderNo: this.orderDetail.OrderNo}})
    },
    getUserOrderLogistics(){
      let params = {
        orderNo: this.$route.query.orderNo
      }
      UserOrderLogistics(params).then(res => {
        if(res.data.success){
          this.logisticsInfo = res.data.response || {}
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    cancelOrder(){
      this.$confirm('确认取消订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let params = {
          orderNo: this.orderDetail.OrderNo
        }
        UserOrderCancel(params).then(res =>{
          if(res.data.success){
            this.$message.success(res.data.msg)
            this.getOrderDetail()
          } else{
            this.$message.error(res.data.msg)
          }
        })
      }).cath(()=>{})
    },
    confirmReceipt(val){
      this.$confirm('确认收货吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let params = {
          orderNo: this.orderDetail.OrderNo
        }
        UserOrderReceipt(params).then(res =>{
          if(res.data.success){
            this.$message.success(res.data.msg)
            this.getOrderDetail()
            this.getUserOrderLogistics()
          } else{
            this.$message.error(res.data.msg)
          }
        })
      }).cath(()=>{})
    },
    paymentFun(){
      this.$router.push({path: '/payment', query: {orderNo: this.orderDetail.OrderNo, money: this.orderDetail.Amount}})
    },
    getOrderDetail(){
      let params = {
        orderNo: this.$route.query.orderNo
      }
      UserOrderDetail(params).then(res => {
        if(res.data.success){
          this.orderDetail = res.data.response || {}
          this.skuData = res.data.response.SkuList[0] || {}
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    timeLeft (date) {
      let time = getTimeLeftToSomeHourLater(date, 2)
      if (time !== '') {
        return `${time.h}小时${time.m}分钟`
      } else {
        return '已超时'
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.order-detail{
  overflow: hidden;
  padding-bottom: 40px;
}
.order-main{
  width: 1200px;
  margin: 0 auto;
  text-align: left;
  .lable{
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
    color: #333333;
    margin: 10px 0;
  }
  .type-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #f40000;
    background: #fffbee;
    padding: 20px 46px 20px 32px;
    .order-type{
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 10px;
    }
    .ordinary-txt{
      font-size: 14px;
      line-height: 22px;
    }
    .red-txt{
      font-size: 14px;
      color: #f40000;
      line-height: 22px;
    }
    .border-btn{
      display: block;
      background: #f40000;
      width: 92px;
      height: 30px;
      line-height: 32px;
      color: #ffffff;
      text-align: center;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .txt-btn{
      display: block;
      width: 92px;
      height: 30px;
      line-height: 30px;
      color: #999999;
      text-align: center;
      cursor: pointer;
    }
  }
  .logistics{
    background: #ffffff;
    border-radius: 10px;
    padding: 33px 32px;
    text-align: center;
    .logistics-box{
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 64px;
        height: 64px;
      }
      span{
        display: inline-block;
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        line-height: 64px;
        margin-left: 16px;
      }
    }
    .logistics-list{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .logistics-left{
        width: 400px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img{
          width: 64px;
          height: 64px;
        }
        p{
          margin-left: 10px;
        }
        span{
          display: block;
          text-align: left;
          margin-bottom: 10px;
        }
      }
      .logistics-right{
        flex: 1;
        text-align: left;
        height: 250px;
        overflow-y: auto;
        padding-top: 5px;
        li{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          padding-bottom: 20px;
          position: relative;
          span,i{
            display: inline-block;
            line-height: 20px;
          }
          .time{
            width: 180px;
            text-align: right;
          }
          .tips{
            flex: 1;
            // width: 70%;
          }
          .none-icon{
            margin: 0 16px;
            display: inline-block;
            width: 15px;
            height: 15px;
            border-radius: 15px;
            background: #d8d8d8;
            position: relative;
            z-index: 10;
          }
        }
        li::before{
          content: '';
          position: absolute;
          border-left: 1px solid #d8d8d8;
          height: 100%;
          left: 203.455px;
        }
        // li:first-child .none-icon{
        //   background: url(../../assets/icon/blue_tick.png) no-repeat center;
        // }
        li:first-child .none-icon::before{
          content: url(../../assets/icon/blue_tick.png);
          width: 25px;
          height: 25px;
          position: relative;
          top: -4px;
          left: -4.5px;
        }
      }
    }
  }
  .order-info{
    background: #ffffff;
    border-radius: 10px;
    padding: 17px 32px 52px;
    font-size: 14px;
    color: #333333;
    p{
      margin-bottom: 20px;
    }
    .bold-txt{
      font-weight: bold;
    }
    .table-box{
      text-align: center;
      .tab-header{
        background: #f3f3f3;
        height: 40px;
        line-height: 40px;
        margin-bottom: 20px;
        >span{
          display: inline-block;
        }
      }
      .tab1{
        width: 590px;
        text-align: left;
      }
      .tab2{
        width: 100px;
      }
      .tab5{
        width: 200px;
      }
      .goods-list{
        .goods-box{
          border: 1px solid #f3f3f3;
          margin-bottom: 20px;
          .lable{
            height: 40px;
            background: #f9f9f9;
            color: #f40000;
            line-height: 40px;
            font-size: 12px;
            font-weight: bold;
            text-align: left;
            padding-left: 20px;
            margin-bottom: 20px;
          }
        }
        .goods-item{
          display: flex;
          padding-bottom: 20px;
          padding-left: 20px;
          padding-top: 20px;
          >span{
            display: inline-block;
          }
          .btn{
            display: block;
            width: 80px;
            margin: 0 auto;
            padding: 3px 5px;
            color: #333333;
            cursor: pointer;
          }
          .btn-border{
            border: 1px solid #cccccc;
            color: #333333;
            margin-bottom: 10px;
          }
          .goods{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            width: 590px;
            height: 80px;
            .img{
              width: 80px;
              height: 80px;
            }
            .txt-box{
              width: 500px;
              height: 80px;
              padding-left: 10px;
              position: relative;
              text-align: left;
              .txt{
                text-align: left;
                display: inline-block;
                color: #333333;
              }
              .buy-num{
                position: absolute;
                bottom: 0;
                left: 10px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
    .price-box{
      text-align: right;
      color: #666666;
      span{
        display: inline-block;
      }
      .money{
        width: 150px;
      }
      .red-txt{
        font-size: 20px;
        font-weight: bold;
        color: #f40000;
        width: 150px;
      }
    }
  }
}
</style>